import { getAccessToken } from '../utils/session';
import { BASE_URL, GET_ENTITY_MASTER_LIST_API } from "../endpoints/apiEndpoints";

export const getEntityList = async (payload) => {
  try {
    const token = getAccessToken();
    const apiUrl = `${BASE_URL}/${GET_ENTITY_MASTER_LIST_API}`;
    
    // Set up request options with authorization header
    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': token
      },
      body: JSON.stringify(payload)
    };
    
    // Make the API request
    const response = await fetch(apiUrl, requestOptions);
    
    // Handle HTTP errors
    if (!response.ok) {
      // Try to get error details from response if available
      let errorMessage;
      try {
        const errorData = await response.json();
        errorMessage = errorData.message || `Request failed with status: ${response.status}`;
      } catch {
        errorMessage = `Request failed with status: ${response.status}`;
      }
      throw new Error(errorMessage);
    }
    
    // Parse and return the successful response
    const data = await response.json();
    return {
      success: true,
      data
    };
    
  } catch (error) {
    // Handle network errors or other exceptions
    console.error('Error fetching entity list:');
    return {
      success: false,
      error: error.message || 'Failed to fetch entity list'
    };
  }
};

export default getEntityList;
